function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import request from '@/utils/request';

/**
 * 门店-列表
 */
export function shopLists() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var datas = _objectSpread({}, params);
  if (datas.addressId && datas.addressId.length) {
    var _ref = datas.addressId || [],
      _ref2 = _slicedToArray(_ref, 2),
      provinceCode = _ref2[0],
      cityCode = _ref2[1];
    datas = _objectSpread(_objectSpread({}, datas), {}, {
      provinceCode: provinceCode,
      cityCode: cityCode
    });
  }
  ;
  delete datas.addressId;
  return request({
    url: "/admin/cake/store/list",
    method: 'GET',
    params: datas
  });
}

/**
 * 门店-删除
 */
export function deleteShop(id) {
  return request({
    url: "/admin/cake/store/remove",
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 门店-编辑
 */
export function updateShop(data) {
  return request({
    url: "/admin/cake/store/save",
    method: 'post',
    data: data
  });
}

/**
 * 门店-详情
 */
export function getDetialShop(id) {
  return request({
    url: "/admin/cake/store/detail",
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 门店-地址
 */
export function getShopFslAddress() {
  var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
  return request({
    url: "/admin/cake/city/list/".concat(level),
    method: 'get'
  });
}
export function getShopSelfAddress() {
  var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
  return request({
    url: "/admin/system/city/list/treeLevel3",
    method: 'get'
  });
}

/**
 * 门店-下拉选择
 */
export function getAllShops(data) {
  return request({
    url: "/admin/cake/store/select",
    method: 'post',
    data: data
  });
}

/**
 * 品牌-列表
 */
export function brandLists(params) {
  return request({
    url: "/admin/cake/brand/list",
    method: 'GET',
    params: params
  });
}

/**
 * 品牌-删除
 */
export function deleteBrand(id) {
  return request({
    url: "/admin/cake/brand/remove/".concat(id),
    method: 'delete',
    params: {
      id: id
    }
  });
}

/**
 * 品牌-编辑
 */
export function updateBrand(data) {
  return request({
    url: "/admin/cake/brand/save",
    method: 'post',
    data: data
  });
}

/**
 * 品牌-详情
 */
export function getDetailBrand(id) {
  return request({
    url: "/admin/cake/brand/detail/".concat(id),
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 品牌-修改排序
 */
export function changeBrandSort(id, sort) {
  return request({
    url: "/admin/cake/brand/sort/".concat(id, "/").concat(sort),
    method: 'post',
    data: {
      id: id,
      sort: sort
    }
  });
}

/**
 * 品牌-修改状态
 */
export function changeBrandState(datas) {
  var _ref3 = datas || {},
    id = _ref3.id,
    status = _ref3.status;
  return request({
    url: "/admin/cake/brand/status/".concat(id, "/").concat(status),
    method: 'post',
    data: {
      id: id,
      status: status
    }
  });
}

/**
 * 品牌-下拉
 */
export function getAllDangaoBrand(keyword, source) {
  return request({
    url: "/admin/cake/brand/select",
    method: 'get',
    params: source ? {
      source: source,
      keyword: keyword
    } : {
      keyword: keyword
    }
  });
}

/**
 * 导入品牌关联自营
 */
export function importBrandCakeBind(formData, brandId) {
  return request({
    url: "/admin/cake/brand/relative-self-cake?brandId=".concat(brandId),
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

/**
 * 移除品牌关联自营
 */
export function removeBrandCakeBind() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: "/admin/cake/brand/remove-relative",
    method: 'POST',
    data: data
  });
}

/**
 * 蛋糕商品-列表
 */
export function getcakeLists(params) {
  return request({
    url: "/admin/cake/product/list",
    method: 'GET',
    params: params
  });
}

/**
 * 蛋糕商品-删除
 */
export function deletecake(id) {
  return request({
    url: "/admin/cake/product/remove/".concat(id),
    method: 'delete',
    params: {
      id: id
    }
  });
}

/**
 * 蛋糕商品-修改状态
 */
export function changeStatecake(data) {
  return request({
    url: "/admin/cake/product/status",
    method: 'post',
    data: data
  });
}

/**
 * 蛋糕商品-详情
 */
export function getDetailcake(productId) {
  return request({
    url: "/admin/cake/product/detail/".concat(productId),
    method: 'get',
    params: {
      productId: productId
    }
  });
}

/**
 * 蛋糕商品-编辑
 */
export function updateEditcake(data) {
  return request({
    url: "/admin/cake/product/save",
    method: 'post',
    data: data
  });
}

/**
 * 蛋糕商品-导入关联
 */
export function importProductRelative(formData) {
  return request({
    url: "/admin/cake/product/import-relative",
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

/**
 * 蛋糕商品-导入修改价格
 */
export function importUpdatePriceCake(formData) {
  return request({
    url: "/admin/cake/product/import-update",
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

/**
 * 蛋糕商品-导出
 */
export function exportCake(data) {
  return request({
    url: "/admin/cake/product/export",
    method: 'POST',
    data: data
  });
}

/**
 * 蛋糕商品-同步
 */
export function syncCakeProduct(data) {
  return request({
    url: "/admin/cake/product/sync",
    method: 'POST',
    data: data
  });
}

/**
 * 蛋糕商品-打标
 */
export function saveCakeTag(data) {
  return request({
    url: "/admin/cake/product/label/save",
    method: 'POST',
    params: data
  });
}

/**
 * 蛋糕商品-修改价格
 */
export function changeCakePrice(data) {
  return request({
    url: "/admin/cake/product/price",
    method: 'POST',
    data: data
  });
}

/**
 * 客户小程序蛋糕-列表
 */
export function getDangaoBusinesss(params) {
  return request({
    url: "/admin/customer/cake/list",
    method: 'GET',
    params: params
  });
}

/**
 * 客户小程序蛋糕-删除
 */
export function deleteBindCake(ids) {
  return request({
    url: "/admin/customer/cake/remove",
    method: 'delete',
    data: {
      ids: ids
    }
  });
}

/**
 * 客户小程序蛋糕-导入关联
 */
export function importProductCakeBind(formData, customerId) {
  return request({
    url: "/admin/customer/cake/import-bind?customerId=".concat(customerId),
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

/**
 * 客户小程序蛋糕-导出
 */
export function exportBindCake(data) {
  return request({
    url: "/admin/customer/cake/export",
    method: 'POST',
    data: data
  });
}

/**
 * 客户小程序蛋糕-修改价格
 */
export function changeBindCakePrice(data) {
  return request({
    url: "/admin/customer/cake/update",
    method: 'POST',
    data: data
  });
}

/**
 * 蛋糕订单-列表
 */
export function getCakeOrderList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = _objectSpread({}, data);
  var _ref4 = params.dataRenage || [],
    _ref5 = _slicedToArray(_ref4, 2),
    startTime = _ref5[0],
    endTime = _ref5[1];
  if (startTime && endTime) {
    params = _objectSpread(_objectSpread({}, params), {}, {
      startTime: startTime,
      endTime: endTime
    });
  }
  ;
  delete params.dataRenage;
  return request({
    url: "/admin/cake/order/list",
    method: 'post',
    data: params
  });
}

/**
 * 蛋糕订单-详情
 */
export function getCakeOrderDetail() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: "/admin/cake/order/detail",
    method: 'get',
    params: params
  });
}

/**
 * 蛋糕订单-导出
 */
export function exportOrderList(data) {
  return request({
    url: "/admin/cake/order/export",
    method: 'post',
    data: data
  });
}

/**
 * 蛋糕订单-同步状态
 */
export function syncOrderState(params) {
  return request({
    url: "/admin/cake/order/sync",
    method: 'get',
    params: params
  });
}

/**
 * 拼团商品-列表
 */
export function getPinGoodsLists(params) {
  return request({
    url: "/admin/store/combination/list",
    method: 'GET',
    params: params
  });
}

/**
 * 拼团商品-删除
 */
export function deletePinGoods(params) {
  return request({
    url: "/admin/store/combination/delete",
    method: 'get',
    params: params
  });
}

/**
 * 拼团商品-修改状态
 */
export function changePinState(params) {
  return request({
    url: "/admin/store/combination/update/status",
    method: 'POST',
    params: params
  });
}

/**
 * 拼团商品-详情
 */
export function getPinGoodsDetial(id) {
  return request({
    url: "/admin/store/combination/info",
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 拼团商品-保存
 */
export function savePinGoods(data) {
  return request({
    url: "/admin/store/combination/save",
    method: 'post',
    data: _handerSubmitDatas(data)
  });
}
var _handerSubmitDatas = function _handerSubmitDatas(data) {
  var _ref6 = data || {},
    id = _ref6.id,
    combinationName = _ref6.combinationName,
    effectiveTime = _ref6.effectiveTime,
    people = _ref6.people,
    quota = _ref6.quota,
    onceQuota = _ref6.onceQuota,
    fillPeople = _ref6.fillPeople,
    _ref6$logisticsType = _ref6.logisticsType,
    logisticsType = _ref6$logisticsType === void 0 ? [] : _ref6$logisticsType,
    shippingType = _ref6.shippingType,
    status = _ref6.status,
    sort = _ref6.sort,
    _ref6$selectIds = _ref6.selectIds,
    selectIds = _ref6$selectIds === void 0 ? [] : _ref6$selectIds,
    activeRange = _ref6.activeRange,
    _ref6$images = _ref6.images,
    images = _ref6$images === void 0 ? [] : _ref6$images,
    shippingFee = _ref6.shippingFee,
    tempId = _ref6.tempId,
    productId = _ref6.productId,
    image = _ref6.image;
  var _ref7 = activeRange || [],
    _ref8 = _slicedToArray(_ref7, 2),
    startTime = _ref8[0],
    endTime = _ref8[1];
  var submits = {
    startTime: startTime,
    endTime: endTime,
    image: image,
    id: id,
    combinationName: combinationName,
    effectiveTime: effectiveTime,
    images: JSON.stringify(images || []),
    people: people,
    quota: quota,
    onceQuota: onceQuota,
    fillPeople: fillPeople,
    logisticsType: logisticsType.length && logisticsType.join(','),
    shippingType: shippingType,
    status: status,
    sort: sort,
    productId: productId,
    skuList: selectIds.length && selectIds.map(function () {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref9 = item || {},
        id = _ref9.id,
        num = _ref9.num,
        defaultPrice = _ref9.defaultPrice;
      return {
        skuId: id,
        num: num,
        defaultPrice: defaultPrice
      };
    })
  };
  if (shippingType == 1) {
    submits['shippingFee'] = shippingFee;
  } else if (shippingType == 0) {
    submits['tempId'] = tempId;
  }
  return submits;
};

/**
 * 拼团商品-初始化
 */
export function initPinGoods(productId) {
  return request({
    url: "/admin/store/combination/init",
    method: 'get',
    params: {
      productId: productId
    }
  });
}

/**
 * 拼团商品-编辑
 */
export function editPinGoods(data) {
  return request({
    url: "/admin/store/combination/update",
    method: 'post',
    data: _handerSubmitDatas(data)
  });
}

/**
 * 商品列表-spu选择
 */
export function getSpuListss(spuName) {
  return request({
    url: '/admin/store/product/list',
    method: 'GET',
    params: {
      page: 1,
      limit: 50,
      spuName: spuName
    }
  });
}

// ------------------------------------------------------------------------------------------------

/**
 * 小程序客户拼团-列表
 */
export function getCtmPinLists(params) {
  return request({
    url: "/admin/customer-combination/list",
    method: 'GET',
    params: params
  });
}

/**
 * 小程序客户拼团-批量删除
 */
export function deleteCtmPin(data) {
  return request({
    url: "/admin/customer-combination/deleteBatch",
    method: 'post',
    data: data
  });
}

/**
 * 小程序客户拼团-查询可拼团的sku
 */
export function getCtmPinSkus(params) {
  return request({
    url: "/admin/customer-combination/auth/list",
    method: 'get',
    params: params
  });
}

/**
 * 小程序客户拼团-保存
 */
export function saveCtmPinSkus(data) {
  return request({
    url: "/admin/customer-combination/saveSelectedSkus",
    method: 'post',
    data: data
  });
}

/**
 * 小程序客户拼团-改价
 */
export function editCtmPinPrice(params) {
  return request({
    url: "/admin/customer-combination/updatePrice",
    method: 'PUT',
    params: params
  });
}

// ------------------------------------------------------------------------------------------------
/**
 * 拼团订单-列表
 */
export function getPinOrderList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = _objectSpread({}, data);
  var _ref0 = params.dataRenage || [],
    _ref1 = _slicedToArray(_ref0, 2),
    startTime = _ref1[0],
    endTime = _ref1[1];
  if (startTime && endTime) {
    params = _objectSpread(_objectSpread({}, params), {}, {
      startTime: startTime,
      endTime: endTime
    });
  }
  ;
  delete params.dataRenage;
  return request({
    url: "/admin/store/pink/list",
    method: 'GET',
    params: params
  });
}

/**
 * 拼团订单-详情
 */
export function getPinOrderDetial(params) {
  return request({
    url: "/admin/store/pink/detailList",
    method: 'GET',
    params: params
  });
}

/**
 * 拼团订单-修改状态
 */
export function changePinOrderState(params) {
  return request({
    url: "/admin/store/pink/updateStatus",
    method: 'GET',
    params: params
  });
}

/**
 * 拼团订单-获取提示信息
 */
export function changePinOrderInfo(params) {
  return request({
    url: "/admin/store/pink/detail",
    method: 'GET',
    params: params
  });
}

/**
 * 拼团订单-日志
 */
export function getPinLog(params) {
  return request({
    url: "/admin/store/pink/logList",
    method: 'GET',
    params: params
  });
}

/**
 * 拼团订单-分享码
 */
export function getPinQrcode(params) {
  return request({
    url: "/admin/store/pink/getShareCode",
    method: 'GET',
    params: params
  });
}

/**
 * 拼团订单-创建拼团
 */
export function createPinStore(data) {
  return request({
    url: "/admin/store/pink/create",
    method: 'post',
    data: data
  });
}

/**
 * 拼团订单-校验小程序是否配置了拼团商品
 */
export function checkCustomer(params) {
  return request({
    url: "/admin/store/pink/checkCustomer",
    method: 'get',
    params: params
  });
}

/**
 * 分销商品导出
 */
export function exportCustomerSkuApi(data) {
  return request({
    url: "/admin/customer-sku/customer-sku",
    method: 'POST',
    data: data
  });
}

/**
 * 移除
 */
export function deleteBatchApi(data) {
  return request({
    url: "/admin/customer-sku/deleteBatch",
    method: 'DELETE',
    data: data
  });
}

/**
 * 更新供货价和售价
 */
export function updatePriceApi(params) {
  params = {
    supplyPrice: params.supplyPrice,
    // 确保 params 中有 supplyPrice 字段
    distributionPrice: params.distributionPrice,
    // 确保 params 中有 distributionPrice 字段
    id: params.id // 确保 params 中有 distributionPrice 字段
  };
  return request({
    url: "/admin/customer-sku/updatePrice/".concat(params.id),
    method: 'PUT',
    params: params
  });
}

/**
 * 更新商家状态
 */
export function updateStatusApi(data) {
  return request({
    url: "/admin/customer-sku/updateStatus/".concat(data.id),
    method: 'PUT',
    params: data
  });
}

/**
 * 分页查询商品SKU信息
 */
export function customerSkuPageApi(params) {
  return request({
    url: "/admin/customer-sku/page",
    method: 'GET',
    params: params
  });
}

/**
 * 保存商品
 */
export function postGoodsApi(data) {
  return request({
    url: "/admin/customer-sku/saveSelectedSkus?customerId=".concat(data.customerId),
    method: 'POST',
    data: data
  });
}

/**
 * 添加商品时查询SKU信息列表（不分页）
 */
export function customerSKUSearchApi(params) {
  return request({
    url: "/admin/customer-sku/search",
    method: 'GET',
    params: params
  });
}

/**
 * 品牌 keyword
 */
export function getBrandrApi(params) {
  return request({
    url: "/admin/store/brand/autoList",
    method: 'GET',
    params: params
  });
}

/**
 * 查询公司
 */
export function getCompanyListApi(str) {
  return request({
    url: "/admin/business/company/list/".concat(str ? str : ''),
    method: 'GET'
  });
}

/**
 * 模糊查询公司
 */
export function getCompanyOptionsApi(par) {
  var data = _objectSpread(_objectSpread({}, par), {}, {
    status: 1
  });
  return request({
    url: "/admin/business/company/options",
    method: 'GET',
    params: data
  });
}

/**
 * 商品分类
 * @param pram
 */
export function categoryApi(params) {
  return request({
    url: '/admin/category/list/tree',
    method: 'GET',
    params: params
  });
}
/**
 * 供应商
 */
export function getSupplierApi(params) {
  return request({
    url: "/admin/business/supplier/autoList",
    method: 'GET',
    params: params
  });
}
// /**
//  * 查询供应商
//  */
// export function getSupplierApi(params) {
//   return request({
//     url: `/admin/business/supplier/list`,
//     method: 'GET',
//     params,
//   });
// }

/**
 * 查询供应商商品
 */
export function getSupplieGoodsrApi(params) {
  return request({
    url: "/admin/customer-suppliers/products/for-new/".concat(params.supplierId),
    method: 'GET',
    params: params
  });
}

/**
 * 分销商品模板导出
 */
export function customerSkuTemplateApi() {
  return request({
    url: "/admin/customer-sku/customer-sku-template",
    method: 'GET'
  });
}

/**
 * 导入修改价格
 */
export function importUpdatePriceApi(formData, customerId) {
  return request({
    url: "/admin/customer-sku/importUpdatePrice?customerId=".concat(customerId),
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

/**
 * 导入修改上下架状态
 */
export function importUpdateStatusApi(formData, customerId) {
  return request({
    url: "/admin/customer-sku/importUpdateStatus?customerId=".concat(customerId),
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

/**
 * 导入修改上下架状态
 */
export function importCustomerSkuApi(formData, customerId) {
  return request({
    url: "/admin/customer-sku/importCustomerSku?customerId=".concat(customerId),
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}
/**
 * 导入更新商品
 */
export function importUpdateCustomerSkuApi(formData, customerId) {
  return request({
    url: "/admin/customer-sku/importUpdateCustomerSku?customerId=".concat(customerId),
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}
export function thirdSkuLists() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var prams = _objectSpread({}, data);
  var _ref10 = prams.dataRenage || [],
    _ref11 = _slicedToArray(_ref10, 2),
    startTime = _ref11[0],
    endTime = _ref11[1];
  delete prams.dataRenage;
  prams = _objectSpread(_objectSpread({}, prams), {}, {
    startTime: startTime,
    endTime: endTime
  });
  return request({
    url: "/admin/fusiling/jd/goods/list",
    method: 'post',
    data: prams
  });
}